
export default {
  props: {
    fundsInfo: {
      type: Array,
      default: []
    },
    preview: {
      type: Object,
      default: {}
    },
    form: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      citytitle: ''
    };
  },
  created () {
  },
  filters: {
    percentage: function (value) {
      if (!value) return '0‰';
      return (value / 1).toFixed(2) + '‰';
    }
  }
};
